
import React from 'react';
import Layout from '@/components/Layout/Layout';
import PowerConverter from '@/components/UnitConverter/PowerConverter';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

const PowerConverterPage = () => {
  return (
    <Layout>
      <div className="container mx-auto max-w-3xl px-4">
        <div className="mb-6">
          <Link to="/converters" className="flex items-center text-primary hover:underline mb-2">
            <ArrowLeft size={16} className="mr-1" />
            Back to All Converters
          </Link>
          <h1 className="text-3xl font-bold mb-2">Power Converter</h1>
          <p className="text-gray-600 mb-6">
            Convert between different units of power, from watts to horsepower and more.
          </p>
        </div>
        
        <div className="mb-8">
          <PowerConverter />
        </div>
        
        <div className="mt-10 prose max-w-none">
          <h2 className="text-xl font-semibold mb-4">About Power Converter</h2>
          <p>
            Our power converter tool helps you convert between different units of power used in 
            physics, engineering, and everyday applications. Power is the rate at which work is done 
            or energy is transferred, and it's measured in various units depending on the context.
          </p>
          
          <h3 className="text-lg font-medium mt-6 mb-2">Common Power Unit Conversions</h3>
          <p>
            Some of the most frequently used power conversions include:
          </p>
          <ul className="list-disc ml-6">
            <li>Converting between watts and kilowatts (electrical applications)</li>
            <li>Converting between horsepower and watts (mechanical applications)</li>
            <li>Converting BTU per hour to watts (heating and cooling)</li>
            <li>Converting between different types of horsepower (mechanical, metric, electrical)</li>
          </ul>
          
          <h3 className="text-lg font-medium mt-6 mb-2">How to Use the Power Converter</h3>
          <p>
            Using our power converter is straightforward:
          </p>
          <ol className="list-decimal ml-6">
            <li>Enter the value you want to convert in the "From" field</li>
            <li>Select the power unit you're converting from</li>
            <li>Select the power unit you want to convert to</li>
            <li>The converted value will appear automatically</li>
          </ol>
          
          <p className="mt-6">
            The power converter supports a wide range of units, including watts (W), kilowatts (kW), 
            megawatts (MW), horsepower (hp) in various forms, BTU per hour, foot-pounds per minute, 
            and more. Whether you're calculating electrical requirements, comparing engine specifications, 
            or working on physics problems, our converter provides accurate conversions between 
            all common power units.
          </p>
        </div>
      </div>
    </Layout>
  );
};

export default PowerConverterPage;
